import { IFilter as ISearchFilter } from '@store/redux/features/search/searchSlice';
import { getLastWord } from '@utils/getLastWord/getLastWord';
import { IFilterOpts, PartialSetter } from '../Heading.types';
import { SEARCH_INVENTORY_KEY } from '../Products';

export const NOT_FOUND_INDEX = -1;

interface MakeSearchFuncParams {
  search: ISearchFilter;
  broadcast: PartialSetter<IFilterOpts>;
  setSearch: (text: string) => void;
  mutationGetManufactorAutocomplete: any;
}

export function makeSearchFunc(params: MakeSearchFuncParams) {
  const { search, broadcast, setSearch, mutationGetManufactorAutocomplete } =
    params;

  return (input: string) => {
    // Change
    setSearch(input);

    // Queue autocomplete
    broadcast(() => {
      const indexOfRecentSearches = search.recentSearches.findIndex(
        item => item.keyHistory === SEARCH_INVENTORY_KEY,
      );
      const indexOfRecentViewed = search.recentViewed.findIndex(
        item => item.keyHistory === SEARCH_INVENTORY_KEY,
      );
      function filterRecentViewed() {
        return search.recentViewed[indexOfRecentViewed].history.filter(item => {
          return (
            (item.labelOne &&
              item.labelOne.toLowerCase().includes(input.toLowerCase())) ||
            (item.labelTwo &&
              item.labelTwo.toLowerCase().includes(input.toLowerCase()))
          );
        });
      }

      function filterRecentSearches() {
        return search.recentSearches[indexOfRecentSearches].history.filter(
          item => item.toLowerCase().includes(input.toLowerCase()),
        );
      }
      const recentSearchesFiltered =
        indexOfRecentSearches > NOT_FOUND_INDEX ? filterRecentSearches() : [];
      const recentViewedFiltered =
        indexOfRecentViewed > NOT_FOUND_INDEX ? filterRecentViewed() : [];

      return {
        recentSearches: recentSearchesFiltered,
        recentViewed: recentViewedFiltered,
      };
    });
    // if (!(input.length === 0 && filter.searchBarText.length === 0)) {
    // setAlreadySearch(true);
    // }
    // setSearch(updateFilterSearch(input));

    // // If a last word exists on this input, and it's not empty.
    if (
      getLastWord(input).length >= 2 &&
      input.charAt(input.length - 1) !== ' '
    ) {
      // Autocomplete on manufacturer
      mutationGetManufactorAutocomplete.mutate(input);
    } else {
      broadcast({
        autocompleteOptions: [],
      });
    }
  };
}
